<template>
	<div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px;display: flex;align-items: center;">
            	<h4 class="application-title" style="font-weight: bold;">កែប្រែអ្នកប្រើប្រាស់</h4>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="margin-bottom:15px; display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<form-input v-model="user.single_id" :label="locale.single_id" type="text" disabled/>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-input v-model="user.name" :label="locale.user_name" disabled/>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-input v-model="user.phone_number" :label="locale.phone_number" disabled/>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-input v-model="user.email" :label="locale.email" disabled />
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-select v-model="user.unit_id" :label="locale.unit" :list="unit_list" />
						</div>
					</div>
				</container>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="margin-bottom:15px; display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
							<div class="text-primary"><b>{{translate(locale.permission_setting)}}</b></div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(action, index) in user.action_list">
							<div class="permission-card">
								<div class="permission-select">
									<md-checkbox class="md-primary" v-model="user.action_list[index].tick"></md-checkbox>
								</div>
								<div class="permission-title"><b>{{action.name}}</b> <br>{{translate(action.description)}}</div>
							</div>
						</div>
					</div>
				</container>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="error-text">
								<p v-for="e in errors">* {{translate(e)}}</p>
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="updateUser()">{{translate(locale.edit_user)}}</md-button>
						</div>
					</div>
				</container>
			</div>
        </div>
    </div>

</template>

<script>
	export default {
		created() {
			// this.getSettings();
			this.getUnit();
			this.getAction();
		},

		data() {
			return {
				loaded: false,
				user: {
					hash: "",
					single_id: "",
					name: "",
					phone_number: "",
					email: "",
					unit_id: "",
					action_list: []
				},
				unit_list: [],
				action_list: [],
				errors: [],
			}
		},
		methods: {
			getUser() {
				this.$http.get(this.config.api + "/user/user/get/" + this.$route.params.hash).then(data => {
					this.user = data.body.data.user;

					let user_action_list = data.body.data.user_action_list;

					for(let i = 0; i < user_action_list.length; i++) {
						for(let j = 0; j < this.action_list.length; j++) {
							if(this.action_list[j].id == user_action_list[i].id) {
								this.action_list[j].tick = "on";
							}
						}
					}

					this.user.action_list = this.action_list;

					this.loaded = true;

				});
			},
			getUnit(more = false) {
				this.$http.post(this.config.api + "/user/unit/list").then(data => {
					this.unit_list = data.body.data;
				})
			},
			getAction(more = false) {
				this.$http.post(this.config.api + "/user/action/list").then(data => {
					let list = [];
					for(let i = 0; i < data.body.data.length; i++) {
						list.push({id: data.body.data[i].id, name: data.body.data[i].name, description: data.body.data[i].description, tick: ""})
					}
					this.action_list = list;
					this.getUser();
				})
			},
			updateUser() {

				if (!this.checkValidation()) {
					return;
				}

				this.$http.post(this.config.api + "/user/user/update", {
					user: this.user
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have updated an account successfully.||អ្នកបានកែប្រែគណនីដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/users");
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.user.single_id).length <= 0) this.errors.push("Please fill in MISTI Single ID.||សូមបំពេញ MISTI Single ID។");
				if (String(this.user.unit_id).length <= 0) this.errors.push("Please fill in Role.||សូមបំពេញអង្គភាព។");

				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>
<style scoped>
	.permission-select {
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 25px;
		
	}
	.permission-card {
		display: flex;
		align-items: center;
		color: #353690;
		padding: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Users/Edit.vue